import { FC } from 'react';
import { Flex, FlexProps, useToken } from '@chakra-ui/react';

/**
 * Can be combined with ContentLayout.Body isScrollable={false}
 * to only scroll a section in the body
 */
const BodyScrollableSection: FC<FlexProps> = (props) => {
  const [space32] = useToken('space', ['space-32']);

  return (
    <Flex
      css={{ scrollbarGutter: 'stable' }}
      flexDirection="column"
      flexGrow={1}
      marginLeft="-space-16"
      maxHeight="100%"
      overflowY="auto"
      // The computation below is here to reserve space on the horizontal borders.
      // Without it, elements that overflow by some pixels (the top-right icon
      // in WarningBox for instance, or the shadows of Card) end up making the div
      // overflow-x scroll, even when the property is explicitly fixed.
      padding="space-16"
      width={`calc(100% + ${space32})`}
      {...props}
    />
  );
};

export default BodyScrollableSection;
